import { render, staticRenderFns } from "./XmEchartsPie.vue?vue&type=template&id=2708173c&scoped=true"
import script from "./XmEchartsPie.vue?vue&type=script&lang=js"
export * from "./XmEchartsPie.vue?vue&type=script&lang=js"
import style0 from "./XmEchartsPie.vue?vue&type=style&index=0&id=2708173c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2708173c",
  null
  
)

export default component.exports